<td>
  <div class="flex gap-1 flex-column">
    <span class="flex gap-2 align-items-center"
      ><i class="w-1rem" [class]="icon"></i> {{ item.name }}</span
    >
    @if (getParent(item); as parent) {
      <span class="flex gap-2 align-items-center text-color-secondary">
        @if (parent.icon) {
          <app-svg-icon class="w-1rem" [key]="parent.icon" />
        } @else {
          <i class="w-1rem" class="fas fa-map"></i>
        }
        {{ parent.name }}</span
      >
    }
  </div>
</td>
<td>
  <span class="flex gap-2">
    <p-button
      class="ml-auto"
      styleClass="p-button-xs"
      (click)="generateView(item)"
      pTooltip="Im Atlas anzeigen"
      [rounded]="true"
      icon="fas fa-eye"></p-button>

    @if (!item.isPoi) {
      <p-button
        styleClass="p-button-xs"
        (click)="markInAtlas(item.key)"
        [pTooltip]="'Im Atlas hervorheben'"
        [rounded]="true"
        [icon]="getTackIcon(item.key)"></p-button>
    }

    @if (!item.isPoi || dataStore.hasDistrictKey()(item.key)) {
      <p-button
        styleClass="p-button-xs"
        (click)="openInAtlas(item)"
        pTooltip="Im Vergleichsbericht öffnen"
        [rounded]="true"
        icon="fas fa-clipboard-list"></p-button>
    }
  </span>
</td>
